module.exports = __webpack_public_path__ + "static/media/exwife-quote-poster.9526f497.webp";